import React, { memo, useEffect, useState } from "react";
import { MDBIcon, MDBBtn, MDBAutocomplete, MDBSelect } from "mdb-react-ui-kit";
import { getMisc } from "../../apiclients/streamsapi_bridge";
import CFNodeUI from "./NodeUI";
import { useUpdateNodeInternals, useReactFlow } from "@xyflow/react";
import { useTranslation } from "react-i18next";
import cfNodesLib from "./nodeComponents.json";

export default memo(({ id, data, isConnectable }) => {
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  const { setNodes, setEdges, getEdges } = useReactFlow();
  const updateNodeInternals = useUpdateNodeInternals();

  console.log("Start...!");
  console.log(data.selected_object);
  let selected_object = {
    title: "",
    timeoutCheck: false,
    timeout: 20,
    cidPTCheck: false,
    callerIdPassThrough: "",
  };

  function onDelete(id) {
    data.onDelete(id);
  }
  const [error, setError] = useState("");
  const [calleridlist, setCalleridList] = useState([]);
  const [callerList, setCallerList] = useState([]);
  const [cidTO, setCidTO] = useState(
    selected_object.timeoutCheck ? selected_object.timeoutCheck : false
  );
  const [cidPT, setCidPT] = useState(
    selected_object.cidPTCheck ? selected_object.cidPTCheck : true
  );
  const [cidT, setCidT] = useState(
    selected_object.timeout ? selected_object.timeout : 20
  );
  const [extNumber, setExtNumber] = useState(
    selected_object.title ? selected_object.title : ""
  );
  const [cIpsth, setCIpsth] = useState(
    selected_object.callerIdPassThrough
      ? selected_object.callerIdPassThrough
      : ""
  );
  const [currentValue, setCurrentValue] = useState("");

  const [displayCalleridList, setDisplayCalleridList] = useState([]);

  async function fetchAAMiscData() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["aaMiscInfo"] }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
    }

    const userList = tdata?.misc?.aaMiscInfo?.user ?? [];
    const groupList = tdata?.misc?.aaMiscInfo?.group ?? [];
    const callerlists = tdata?.misc?.aaMiscInfo?.cid_pass ?? [];
    const callids = (tdata?.misc?.aaMiscInfo?.cid_pass ?? []).map((call) => ({
      text: call.addl_info,
      value: call.phnum,
    }));

    const mergeWithSortList = [...userList, ...groupList].sort((a, b) =>
      a?.title?.localeCompare(b?.title)
    );
    setCallerList(callerlists);
    setDisplayCalleridList(callids);
    if (!data.handles) {
      data.handles = [];
    }
    if (data.selected_object) {
      setCidTO(data.selected_object.timeoutCheck);
      setCidPT(data.selected_object.cidPTCheck);
      setCidT(data.selected_object.timeout);
      setExtNumber(data.selected_object.title);
      setCIpsth(data.selected_object.callerIdPassThrough);
    }
  }

  useEffect(() => {
    fetchAAMiscData();
    if (!data.handles) {
      data.handles = [];
    }
    data.actionExecutor({ action: 0 });
  }, []);
  const onSearchCallerId = (value) => {
    if (value.trim() !== "") {
      const filteredData = callerList.filter((item) =>
        item.addl_info.toString().includes(value)
      );
      setDisplayCalleridList(filteredData);
    } else {
      setDisplayCalleridList([]);
    }
  };
  const command = 0;
  function handleCallerIdChange(value, id) {
    console.log(value);
    setCurrentValue(value);
    let updateObj = {};
    if (value != "") {
      const { phnum } =
        calleridlist.find((item) => item.addl_info === value.trim()) || {};

      updateObj = {
        callerid: phnum,
      };

      if (id !== -1) {
        updateObj.command = parseInt(id);
      }
    }
    updatecIpsth(value);
  }

  const updateExtNumber = (e) => {
    const value = e.target.value.trim();
    if (!value) {
      setError("");
      setNodes((nds) =>
        nds.map((n) =>
          n.active === true
            ? {
              ...n,
              style: {
                ...n.style,
                border: cfNodesLib[n.type]
                  ? cfNodesLib[n.type].style.border
                  : "2px solid green",
              },
              active: false,
              selected: false,
            }
            : n
        )
      );
    }

    setExtNumber(e.target.value);
    data.actionExecutor({
      action: 3,
      value: {
        title: e.target.value,
        timeoutCheck: cidTO,
        cidPTCheck: cidPT,
        timeout: cidT,
        callerIdPassThrough: cIpsth,
      },
    });
  };
  const updatecidTo = (e) => {
    setCidT(e.target.value);
    data.actionExecutor({
      action: 3,
      value: {
        title: extNumber,
        timeoutCheck: cidTO,
        cidPTCheck: cidPT,
        timeout: e.target.value,
        callerIdPassThrough: cIpsth,
      },
    });
  };
  const updatecidToCheck = (value) => {
    console.log(value);
    //setCidTO(value);
    if (value) {
      data.handles = [
        { name: "Timeout", label: "Timeout", value: cidT, id: 1, top: 150 },
      ];
      setNodes((nodes) =>
        nodes.map((node) =>
          node.id === id
            ? {
                ...node,
                data: {
                  ...node.data,
                  handles: [
                    {
                      name: "Timeout",
                      label: "Timeout",
                      value: cidT,
                      id: 1,
                      top: 150,
                    },
                  ],
                },
              }
            : node
        )
      );
      data.actionExecutor({
        action: 2,
        value: [
          { name: "Timeout", label: "Timeout", value: cidT, id: 1, top: 150 },
        ],
      });
      console.log("if");
    } else {
      console.log("else");
      data.handles = [];
      data.actionExecutor({
        action: 2,
        value: [],
      });
      setNodes((nodes) =>
        nodes.map((node) => {
          if (node.id === id) {
            const newHandles = node.data.handles.slice(0, -1); // Remove the last handle

            // Remove edges connected to the deleted handle
            const updatedEdges = getEdges().filter(
              (edge) =>
                !node.data.handles.some(
                  (handle) =>
                    handle.id === edge.source || handle.id === edge.target
                )
            );

            setEdges(updatedEdges); // Update edges state

            return {
              ...node,
              data: {
                ...node.data,
                handles: newHandles,
              },
            };
          }
          return node;
        })
      );
    }
    data.selected_object = {
        title: extNumber,
        timeoutCheck: value ? 1 : 0 ,
        cidPTCheck: cidPT,
        timeout: cidT,
        callerIdPassThrough: cIpsth,
      };
    console.log(data.selected_object)
    setCidTO(value);
    updateNodeInternals(id);
  };
  const updatecIpsth = (value) => {
    //setCIpsth(value);
    data.actionExecutor({
      action: 3,
      value: {
        title: extNumber,
        timeoutCheck: cidTO,
        cidPTCheck: cidPT,
        timeout: cidT,
        callerIdPassThrough: value,
      },
    });
  };
  const updatecIpsthchcek = (value) => {
    setCidPT(value);
    data.actionExecutor({
      action: 3,
      value: {
        title: extNumber,
        timeoutCheck: cidTO,
        timeout: cidT,
        cidPTCheck: value,
        callerIdPassThrough: cIpsth,
      },
    });
  };
  const handleBlur = (e) => {
    const value = e.target.value.trim();
    if (!value) {
      setError("");
      // setExtNumber(data.selected_object ? data.selected_object.title : "");
      setNodes((nds) =>
        nds.map((n) =>
          n.active === true
            ? {
              ...n,
              style: {
                ...n.style,
                border: cfNodesLib[n.type]
                  ? cfNodesLib[n.type].style.border
                  : "2px solid green",
              },
              active: false,
              selected: false,
            }
            : n
        )
      );
      return;
    }
  
    // Must be exactly 10 digits (optionally prefixed with +1 or 1)
    const phoneRegex = /^(\+1|1)?[2-9]\d{2}[2-9]\d{6}$/;
  
    if (!phoneRegex.test(value)) {
      setError("Please enter valid input");
      return;
    }
  
    setError("");
  };
  
  

  return (
    <>
      <CFNodeUI
        headerClass="darkBlueNodeHeader"
        data={data}
        targethandles={data.handles}
        deletable={true}
        onDelete={onDelete}
        bodyContnent={
          <>
            <input
              type="text"
              className="mb-1"
              value={extNumber}
              placeholder="External Number"
              onKeyDown={(event) => {
                // Allow control keys like Backspace, Delete, Arrow keys, and Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
                if (
                  !/[0-9]/.test(event.key) &&
                  ![
                    "Backspace",
                    "Delete",
                    "ArrowLeft",
                    "ArrowRight",
                    "Tab",
                  ].includes(event.key) &&
                  !(
                    event.ctrlKey &&
                    ["a", "c", "v", "x"].includes(event.key.toLowerCase())
                  )
                ) {
                  event.preventDefault();
                }
              }}
              onPaste={(event) => {
                // Allow pasting but remove non-numeric characters
                event.preventDefault();
                const pastedData = event.clipboardData
                  .getData("text")
                  .replace(/\D/g, ""); // Extract and clean pasted text
                event.target.value = pastedData.slice(0, 11); // Enforce max length
                updateExtNumber(event)
              }}
              onChange={(e) => updateExtNumber(e)}
              onBlur={handleBlur}
              maxLength={11} 
            />
            <p className="text-danger">&nbsp;{error}</p>

            <div className="inlineAnnounceOptions">
              <span>
                <b>Timeout</b>
              </span>
              <span className="mb-1">
                <label className="">
                  <input
                    type="checkbox"
                    value={cidTO}
                    checked={cidTO}
                    onChange={(e) => updatecidToCheck(e.target.checked)}
                  />
                  {/* <span className="checkmark"></span> */}
                </label>
              </span>
            </div>
            <input
              type="text"
              className="mb-1"
              style={{ width: "50px", position: "relative", zIndex: 999 }}
              placeholder="seconds"
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              value={cidT == -1  || cidT == "-1" ? "0" : cidT}
              disabled={!cidTO}
              onChange={(e) => updatecidTo(e)}
              maxLength={3}
            />

            <div className="inlineAnnounceOptions">
              <span>
                <b>{t("CallerIDpasstrough")}</b>
              </span>
              <span className="mb-1">
                <label className="">
                  <input
                    type="checkbox"
                    checked={cidPT}
                    onChange={(e) => updatecIpsthchcek(!cidPT)}
                  />
                  {/* <span className="checkmark"></span> */}
                </label>
              </span>
            </div>
            <div className="nodeSelectLinkIcon">
              <MDBSelect
                data={[
                  { text: "--Select Caller ID--", value: "" },
                  ...displayCalleridList,
                ]}
                id="country"
                value={currentValue ? currentValue : cIpsth}
                placeholder="--Select Caller ID--"
                onChange={(e) => {
                  if (e && e.value) {
                    handleCallerIdChange(
                      e.value,
                      command != undefined ? parseInt(command) : -1
                    );
                  }
                }}
                title={cIpsth}
                search
                disabled={cidPT}
              />
            </div>
          </>
        }
        targetNode={true}
      />
    </>
  );
});
